import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "56",
  height: "18",
  fill: "none",
  viewBox: "0 0 56 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#373838",
      d: "M4.677 7.332v6.083q0 .635.294.93.315.272 1.04.272h1.468v2.679H5.49q-4 0-4-3.904v-6.06H0v-2.61h1.491v-3.11h3.186v3.11H7.48v2.61zm4.263 3.631q.001-1.905.746-3.382.768-1.475 2.057-2.27 1.31-.794 2.914-.794 1.4 0 2.44.568 1.062.567 1.695 1.43V4.722h3.186v12.574h-3.186v-1.839q-.61.885-1.695 1.476-1.061.567-2.462.567a5.36 5.36 0 0 1-2.892-.817q-1.29-.817-2.057-2.293-.745-1.497-.745-3.427m9.852.046q0-1.158-.452-1.975-.452-.84-1.22-1.271a3.2 3.2 0 0 0-1.65-.454q-.881 0-1.626.431-.746.431-1.22 1.271-.453.818-.452 1.952 0 1.136.452 1.998.474.84 1.22 1.293a3.15 3.15 0 0 0 1.627.454q.88 0 1.649-.431a3.3 3.3 0 0 0 1.22-1.271q.452-.84.452-1.997M28.23.5v16.796h-3.163V.5zm6.29 0v16.796h-3.164V.5zm8.683 17q-1.808 0-3.254-.794a5.95 5.95 0 0 1-2.282-2.293q-.813-1.475-.813-3.404t.836-3.405a5.9 5.9 0 0 1 2.327-2.27q1.47-.817 3.276-.817 1.809 0 3.277.817a5.75 5.75 0 0 1 2.304 2.27q.86 1.476.859 3.405 0 1.928-.881 3.404a6 6 0 0 1-2.35 2.293q-1.47.794-3.299.794m0-2.769q.858 0 1.604-.409.769-.43 1.22-1.27.453-.84.452-2.043 0-1.793-.949-2.747-.926-.976-2.282-.976t-2.282.976q-.903.954-.904 2.747 0 1.793.882 2.769.903.953 2.259.953"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2E7CF6",
      d: "M53.127 17.455q-.858 0-1.423-.522a1.83 1.83 0 0 1-.543-1.34q0-.795.543-1.316.564-.545 1.423-.545.836 0 1.378.545.543.522.543 1.317t-.543 1.339q-.541.522-1.378.522"
    }, null, -1)
  ])))
}
export default { render: render }